/* eslint-disable camelcase */
import React, { useState, useEffect } from 'react';
import KickImage from 'Reuseables/KickImage';
import { connect } from 'react-redux';
import { toast } from 'react-toastify';

// ========= module component import section ========= //
import { Modal } from 'reactstrap';
import { IconContext } from 'react-icons';
import { GrClose } from 'react-icons/gr';
import _ from 'lodash';
import moment from 'moment';
import CurrencyFormat from 'react-currency-format';
// ====== end of module component import section ====== //

// ========= project component import section ========= //
import {
  emptyImage,
  getCloudImageUrl,
  _VERIFYING_BID,
  _VERIYING_PAYMENT,
} from '../../../utils';
import {
  accessoriesCondition,
  boxCondition,
  boxHandbag,
  defectCondition,
  dustBag,
  formatCurrency,
  formatNumber,
  formatRupiah,
  handbagCondition,
  sneakersCondition,
  convertToRupiah,
  sneakersDefect,
  displayItem,
  yellowing,
  sneakerDefectsCondition
} from '../../../utils/Helpers';
import { isNumeric } from '../../../helpers/regex';
import { OFFER_GAP, VALIDATE_AMOUNT_DELAY } from '../../../config';
// ====== end of project component import section ====== //

// ========= action import section ========= //
import { doAcceptOfferRequest } from '../../../actions/offerAction';
// ====== end of action import section ====== //

// ========= interface import section ========= //
import DataOfferInterface, {
  MaxAmountStateInterface,
} from '../../../interface/reducers/offer';
import DataPostalCodeInterface, {
  CourierStateInterface,
} from '../../../interface/reducers/postalCode';
import AuthInterface from '../../../interface/reducers/auth';
import { ModalAlert } from '../../Modals';
import DataHistoryInterface, {
  DataPenjualanInterface,
} from '../../../interface/reducers/history';
import DataSellingInterface, {
  SuspendedStateInterface,
} from '../../../interface/reducers/selling';
import { OfferInterface } from '../../../interface/bid';
import { handleSuspended } from '../../../actions/saleActions';
// ====== end of interface import section ====== //

const fixingAmount = (value: any | number) => {
  if (isNumeric(value)) {
    let parsed = parseFloat(value);
    parsed -= value % OFFER_GAP;
    const summary = parsed + OFFER_GAP;
    const multipleGAP = value % OFFER_GAP;

    return parsed < OFFER_GAP
      ? OFFER_GAP
      : multipleGAP === 0
      ? parsed
      : summary;
  }
  return value;
};

type PayloadAcceptOffer = {
  bid_id: number;
};

type PayloadDeleteListing = {
  status: string;
};

type PayloadChangePrice = {
  status: string;
  asking_price: number;
};

type stateToProps = {
  dataOffer: DataOfferInterface;
  dataPostalCode: DataPostalCodeInterface;
  dataAuth: AuthInterface;
  dataHistory: DataHistoryInterface;
  dataSelling: DataSellingInterface;
};

interface ModalCurrent extends stateToProps {
  isOpen: boolean;
  ratio: number;
  couriers: CourierStateInterface;
  maxAmount: MaxAmountStateInterface;
  currency: string;
  data: DataPenjualanInterface;
  suspended: SuspendedStateInterface;
  onToggle: () => any;
  callbackAfterUpdate?: (...args: any) => any;
  doAcceptOffer: (query: number, payload: PayloadAcceptOffer) => Promise<any>;
  doDeleteListing: (
    idSale: number,
    status: PayloadDeleteListing,
  ) => Promise<any>;
  doChangePrice: (idSale: number, body: PayloadChangePrice) => Promise<any>;
}

/**
 * Modal for Selling Current Detail on User Dashboard section for Kick Avenue 3.0 Website.
 * Author: Rifqy Zacky Ariadhy (rifqyzackya@gmail.com)
 * ===============================================
 * @param {ModalCurrent} props for this component.
 * @return {JSX.Element}
 */
function ModalCurrentComponent({
  isOpen,
  onToggle,
  ratio,
  currency,
  callbackAfterUpdate,
  data,
  doAcceptOffer,
  doDeleteListing,
  doChangePrice,
  suspended
}: ModalCurrent): JSX.Element {
  const [status, setStatus] = useState('');

  // ============== Start of updated current selling state data ==============
  const [currentAmount, setCurrentAmount] = useState<number>(0);

  const [error, setError] = useState<any>({});
  const [errorSubmit, setErrorSubmit] = useState('');
  const [submitConfirmation, setSubmitConfirmation] = useState(false);
  const [submitPrice, setSubmitPrice] = useState(false);
  const [_openModalWarning, set_openModalWarning] = useState(false);
  // ============== End of updated current selling state data ==============

  useEffect(() => {
    let errorTxt = '';
    let isError = false;
    if (currentAmount === 0 || !currentAmount) {
      isError = true;
      errorTxt = 'Please fill in the amount of your asking price.';
    } else if (!isNumeric(currentAmount)) {
      isError = true;
      errorTxt = 'This field must be numeric.';
    }
    setError({
      ...error,
      askingPrice: { isError, text: errorTxt },
    });
  }, [currentAmount]);

  // ============== Start of amount text input method helper ==============
  const [intervalKeyDown, setIntervalKeyDown] = useState(undefined);
  const onFixingAmount = (val: number) => {
    setCurrentAmount(fixingAmount(val));
  };
  const onChangeAmount = (e: any) => {
    let dataAmount = currentAmount;
    dataAmount = parseInt(
      e.target.value
        ? `${e.target.value.replace(/[\. ,:-]+/g, '')}.00`
        : '0.00',
    );
    setCurrentAmount(dataAmount);
    if (intervalKeyDown) clearTimeout(intervalKeyDown);
    const newIntervalKeyUp = setTimeout(() => {
      onFixingAmount(dataAmount);
      setIntervalKeyDown(undefined);
    }, VALIDATE_AMOUNT_DELAY);
    setIntervalKeyDown(newIntervalKeyUp);
  };

  const onBlur = () => {
    if (intervalKeyDown) clearTimeout(intervalKeyDown);
    setIntervalKeyDown(undefined);
    onFixingAmount(currentAmount);
  };
  // ============== End of amount text input method helper ==============

  const [modalType, setModalType] = useState('');
  const _modalWarningToggle = () => {
    set_openModalWarning(!_openModalWarning);
    if (_openModalWarning) {
      setModalType('');
    }
  };

  const checkOffer = (offer: OfferInterface[]) => {
    if (offer) {
      if (offer.length === 0) return false;
      const result = offer.filter(
        (it, index) =>
          it.status === _VERIYING_PAYMENT[0] || it.status === _VERIFYING_BID[0],
      );
      return result.length > 0 ? true : false;
    }
  };

  useEffect(() => {
    if (data) {
      setErrorSubmit('');
      setCurrentAmount(
        // parseInt(
        //   formatNumber(
        //     parseInt(data.asking_price),
        //     ratio === 1 ? 0 : 2,
        //   ),
        // ),
        parseInt(data.asking_price),
      );
      if (checkOffer(data.offer)) {
        setStatus('under_reservation');
      } else if (
        (parseInt(data.asking_price) > parseInt(data.lowest_ask) &&
          data.status == 'approved' &&
          data.quantity > 0 &&
          parseInt(data.lowest_ask) === 0 &&
          data.is_expired) ||
        (parseInt(data.asking_price) > parseInt(data.lowest_ask) &&
          data.status == 'approved' &&
          data.quantity > 0 &&
          parseInt(data.lowest_ask) !== 0)
      ) {
        setStatus('waiting_in_line');
      } else if (
        parseInt(data.asking_price) > parseInt(data.lowest_ask) &&
        data.status === 'approved' &&
        data.quantity <= 0
      ) {
        setStatus('out_of_stock');
      } else if (
        parseInt(data.asking_price) <= parseInt(data.lowest_ask) &&
        !checkOffer(data.offer)
      ) {
        setStatus('active');
      } else {
        setStatus('awaiting_review');
      }
    }
  }, [data]);

  useEffect(() => {
    if (isOpen) {
      setCurrentAmount(parseInt(data.asking_price));
    }
  }, [isOpen]);

  // If data is available, then show the modal
  if (data) {
    const isDefects = data?.defects?.length > 0
    const isSameAsBefore = currentAmount === parseInt(data.asking_price);
    const imageUrl = data.product_variant?.product_variant_images?.length
      ? data.product_variant?.product_variant_images[0].URL
      : null;
    const category = data.product_variant?.product?.category.name;
    const uniqueDefects = _.uniqBy(
      isDefects ? data.defects : null,
      'name',
    );
    const dustBagCondition = uniqueDefects
      ? uniqueDefects.find((a: any) => a.name === 'DUST_BAG' && a.value)
      : {};
    const boxConditions = uniqueDefects
      ? uniqueDefects.find((a: any) => a.name === 'BOX')
      : {};
    const hideBoxInfo = data?.product_variant?.hide_box_info;
    const isVintage = data.product_variant?.vintage;
    const sneakersDetailArr = [
      isVintage? "Vintage" : sneakersCondition(data.sneakers_condition),
      hideBoxInfo ? '' : boxCondition(data.box_condition),
      accessoriesCondition(data.missing_accessories),
      yellowing(data.yellowing),
      displayItem(data.display_item),
      sneakersDefect(data.sneakers_defect), 
      isDefects ? sneakerDefectsCondition(uniqueDefects) : ''
    ];
    const sneakersDetail = sneakersDetailArr.filter((item) => item !== '')
      .map((items) => items)
      .join(' / ');
    const luxuryDetailArr = [
      sneakersCondition(data.sneakers_condition),
      accessoriesCondition(data.missing_accessories),
      dustBag(dustBagCondition),
      hideBoxInfo ? '' : boxHandbag(boxConditions),
      isDefects ? handbagCondition(uniqueDefects) : '',
    ];
    const luxuryDetail = luxuryDetailArr
      .filter((item) => item !== '' && item !== 'Missing Box')
      .map((item) => item)
      .join(' / ');

    const isTicket = data?.product_variant?.product?.name.includes('Ticket');

    const onSave = () => {
      if (!isSameAsBefore) {
        setSubmitPrice(true);
        const payload = {
          status: data.status,
          asking_price: currentAmount,
        };
        doChangePrice(data.id, payload).then(() => {
          onToggle();
          callbackAfterUpdate();
          setSubmitPrice(false);
        })
        .catch((e) => {
          const errorMessage = suspended.error ? suspended.error.message : e
          setSubmitPrice(false)
          toast.error(`${errorMessage}`,
            {
              position: 'top-right',
              autoClose: 5000,
              closeOnClick: true,
              pauseOnHover: true,
            },
          )
        });
      }
    };

    const onDelete = () => {
      if (!submitConfirmation) set_openModalWarning(true);
    };

    const onConfirmModal = () => {
      if (modalType === 'sale') {
        setSubmitConfirmation(true);
        _modalWarningToggle();
        const payload = {
          bid_id: parseInt(data.highest_bid.id),
        };

        doAcceptOffer(data.id, payload).then(() => {
          onToggle();
          callbackAfterUpdate();
          setSubmitConfirmation(false);
        });
      } else {
        setSubmitConfirmation(true);
        _modalWarningToggle();
        const payload = {
          status: 'cancelled',
        };

        doDeleteListing(data.id, payload).then(() => {
          onToggle();
          callbackAfterUpdate();
          setSubmitConfirmation(false);
        });
      }
    };

    const onSellNow = () => {
      if (data.highest_bid) {
        setModalType('sale');
        _modalWarningToggle();
      }
    };

    const txtStatus = status.split('_').join(' ');

    return (
      <Modal
        className="offer-detail-modal"
        toggle={onToggle}
        isOpen={isOpen}
        centered
      >
        <>
          <div className={'content-modal'}>
            <div className={'header-section'}>
              <div className={'left'}>
                <p className={'product-title'}>
                  {data.product_variant?.display_name}
                </p>
                <p className={'product-sku'}>{data.product_variant?.SKU}</p>
              </div>
              <div className={'right'}>
                <div>
                  {category === 'handbags' ||
                  (category === 'lifestyles' &&
                    data.size?.US.toLowerCase() !== 'all size') ? (
                    <div className={'size-container'}>
                      <p>{data.size?.US}</p>
                    </div>
                  ) : (
                    <div className={'size-container'}>
                      <p>US {data.size?.US}</p>
                    </div>
                  )}
                </div>
              </div>
            </div>
            <div className={'image-section'}>
              <KickImage
                src={
                  imageUrl
                    ? getCloudImageUrl(imageUrl, 300)
                    : emptyImage(category)
                }
              />
            </div>
            {status !== 'active' && (
              <div className={'status-section'}>
                <p>{txtStatus}</p>
              </div>
            )}
            <div className={'grey-box-section'}>
              <div className={'container-row'}>
                <div className={'item'}>
                  <p className={'title'}>Consignment ID</p>
                  <p className={'value'}>{data.consignment_id || '-'}</p>
                </div>
                {status !== 'active' && (
                  <div className={'item'}>
                    <p className={'title right'}>Approved at</p>
                    <p className={'value right'}>
                      {data.approved_at
                        ? moment(data.approved_at).format('MMMM DD, YYYY')
                        : '-'}
                    </p>
                  </div>
                )}
              </div>
              <div className={'container no-mb'}>
                <p className={'title'}>Product Conditions</p>
                {
                  isTicket ?
                  <p className={'value'}>{sneakersCondition(data.sneakers_condition)}</p> :
                  <p className={'value'}>
                    {category === 'handbags'
                      ? luxuryDetail
                      : sneakersDetail}
                  </p>
                }
              </div>
            </div>
            <div className={'selling-section'}>
              <p>Selling Price</p>
              <div className={'price-container'}>
                <p className={'currency'}>{currency}</p>
                <CurrencyFormat
                  decimalSeparator={','}
                  thousandSeparator={'.'}
                  value={convertToRupiah(currentAmount)}
                  // name={'offerAmount'}
                  onChange={onChangeAmount}
                  onBlur={onBlur}
                  disabled={status === 'under_reservation'}
                />
                <div
                  className={`button-save ${
                    (status === 'under_reservation') || (parseInt(currentAmount) === parseInt(data.asking_price)) ? 'disabled' : ''
                  }`}
                  onClick={onSave}
                >
                  <p>{submitPrice ? 'Submitting...' : 'Save Changes'}</p>
                </div>
              </div>
            </div>
            <div className={'price-seller-section'}>
              <div className={'lowest'}>
                <p className={'title'}>Lowest Price</p>
                <p className={'value'}>
                  {formatCurrency(data.lowest_ask, ratio, currency)}
                </p>
              </div>
              <div className={'highest'}>
                <p className={'title'}>Highest Offer</p>
                <p className={'value'}>
                  {formatCurrency(
                    data.highest_bid ? data.highest_bid.amount : 0,
                    ratio,
                    currency,
                  )}
                </p>
              </div>
              <div
                className={`sell ${!data.highest_bid ? 'disabled' : ''}`}
                onClick={onSellNow}
              >
                <p>Sell Now</p>
              </div>
            </div>

            <p className={'bottom-text'}>
              By clicking SELL NOW, you have agreed to the HIGHEST OFFER price.
              The order will be placed and a notification will be sent to the
              potential buyer to complete the payment. Should the payment
              process fail, your listing will be automatically adjusted that
              amount.
            </p>

            {status !== 'under_reservation' && (
              <div className={'button-delete'} onClick={onDelete}>
                {submitConfirmation
                  ? 'Deleting your Listing...'
                  : 'Delete Listing'}
              </div>
            )}
          </div>

          <ModalAlert
            isOpen={_openModalWarning}
            onToggle={_modalWarningToggle}
            title={modalType === 'sale' ? '' : 'Delete Listing'}
            contentText={
              modalType === 'sale'
                ? 'Are you sure want to accept this offer?'
                : 'Are you sure you want to delete your listing?'
            }
            showButton
            onSubmit={onConfirmModal}
          />
          <div className={'close-button'} onClick={onToggle}>
            <IconContext.Provider value={{ color: '#242424', size: '12px' }}>
              <div>
                <GrClose />
              </div>
            </IconContext.Provider>
          </div>
        </>
      </Modal>
    );
  }
  // Not rendering the modal component is data is unavailable to prevent undefined error
  return <div />;
}

const mapStateToProps = (state: stateToProps) => {
  return {
    currency: state.dataAuth.userCurrency.currency,
    ratio: state.dataAuth.userCurrency.ratio,
    suspended: state.dataSelling.suspended
  };
};

const mapDispatchToProps = (dispatch: (arg0: any) => any) => {
  return {
    doAcceptOffer: (query: number, payload: PayloadAcceptOffer) =>
      dispatch(doAcceptOfferRequest(query, payload)),
    doDeleteListing: (idSale: number, status: PayloadDeleteListing) =>
      dispatch(handleSuspended(idSale, status)),
    doChangePrice: (idSale: number, body: PayloadChangePrice) =>
      dispatch(handleSuspended(idSale, body)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ModalCurrentComponent);
